
import {
    FETCH_DASHBOARD_DATA_REQUEST,
    FETCH_DASHBOARD_DATA_SUCCESS,
    FETCH_DASHBOARD_DATA_FAIL,
  } from "./DashboardCardType";
  
  import {
    getTelecallerDashboard,
    getReceptionistDashboard,
    getDoctorDashboard,
    getCounsellorDashboard,
    getServiceCallerDashboard,
    getMedicalDashboard,
  } from "../../services/DashboardCardService";
  

  export const fetchTelecallerDashboardAction = () => {
    return async (dispatch) => {
      dispatch({ type: FETCH_DASHBOARD_DATA_REQUEST });
      try {
        const res = await getTelecallerDashboard();
  
        // ✅ SEND ONLY INNER DATA
        dispatch({
          type: FETCH_DASHBOARD_DATA_SUCCESS,
          payload: res.data.data,
        });
  
      } catch (err) {
        dispatch({
          type: FETCH_DASHBOARD_DATA_FAIL,
          payload:
            err.response?.data?.message ||
            "Failed to fetch telecaller dashboard",
        });
      }
    };
  };
  
  export const fetchReceptionistDashboardAction = () => {
    return async (dispatch) => {
      dispatch({ type: FETCH_DASHBOARD_DATA_REQUEST });
      try {
        const res = await getReceptionistDashboard();
        dispatch({ type: FETCH_DASHBOARD_DATA_SUCCESS, payload: res.data });
      } catch (err) {
        dispatch({
          type: FETCH_DASHBOARD_DATA_FAIL,
          payload: err.response?.data?.message || "Failed to fetch receptionist dashboard",
        });
      }
    };
  };
  
  export const fetchDoctorDashboardAction = () => {
    return async (dispatch) => {
      dispatch({ type: FETCH_DASHBOARD_DATA_REQUEST });
      try {
        const res = await getDoctorDashboard();
        dispatch({ type: FETCH_DASHBOARD_DATA_SUCCESS, payload: res.data });
      } catch (err) {
        dispatch({
          type: FETCH_DASHBOARD_DATA_FAIL,
          payload: err.response?.data?.message || "Failed to fetch doctor dashboard",
        });
      }
    };
  };
  
  export const fetchCounsellorDashboardAction = () => {
    return async (dispatch) => {
      dispatch({ type: FETCH_DASHBOARD_DATA_REQUEST });
      try {
        const res = await getCounsellorDashboard();
        dispatch({ type: FETCH_DASHBOARD_DATA_SUCCESS, payload: res.data });
      } catch (err) {
        dispatch({
          type: FETCH_DASHBOARD_DATA_FAIL,
          payload: err.response?.data?.message || "Failed to fetch counsellor dashboard",
        });
      }
    };
  };
  
  export const fetchMedicalDashboardAction = () => {
    return async (dispatch) => {
      dispatch({ type: FETCH_DASHBOARD_DATA_REQUEST });
      try {
        const res = await getMedicalDashboard();
        dispatch({ type: FETCH_DASHBOARD_DATA_SUCCESS, payload: res.data });
      } catch (err) {
        dispatch({
          type: FETCH_DASHBOARD_DATA_FAIL,
          payload: err.response?.data?.message || "Failed to fetch medical dashboard",
        });
      }
    };
  };
  
  export const fetchServiceCallerDashboardAction = () => {
    return async (dispatch) => {
      dispatch({ type: FETCH_DASHBOARD_DATA_REQUEST });
      try {
        const res = await getServiceCallerDashboard();
        dispatch({ type: FETCH_DASHBOARD_DATA_SUCCESS, payload: res.data });
      } catch (err) {
        dispatch({
          type: FETCH_DASHBOARD_DATA_FAIL,
          payload: err.response?.data?.message || "Failed to fetch service caller dashboard",
        });
      }
    };
  };